import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadCapture = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { email: email.trim() });
      toast.success("Capítulo enviado! Verifique sua caixa de entrada.", {
        description: "Seu primeiro capítulo gratuito de ESTÓICO está a caminho.",
      });
      setEmail("");
    } catch {
      toast.error("Não foi possível enviar. Verifique o e-mail e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="lead-capture-section" className="py-20 md:py-24 bg-[#0f0f13] border-y border-[#d4af37]/10">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Ainda em dúvida?</p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
            Leia o <span className="text-gold-gradient italic">primeiro capítulo</span> de graça
          </h2>
          <p className="mt-4 text-sm sm:text-base text-zinc-400 leading-relaxed">
            Deixe seu e-mail e receba gratuitamente o Capítulo I — A Dicotomia do Controle —
            antes de decidir.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <form data-testid="lead-form" onSubmit={submit} className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input
              data-testid="lead-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu melhor e-mail"
              className="flex-1 bg-[#14141a] border border-[#d4af37]/20 rounded-full px-6 py-4 text-sm text-[#f4f1ea] placeholder:text-zinc-600 outline-none focus:border-[#d4af37]/60 transition-colors"
            />
            <button
              data-testid="lead-submit-button"
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 bg-gold-gradient text-[#08080a] font-bold text-sm px-8 py-4 rounded-full transition-transform duration-300 hover:scale-[1.04] disabled:opacity-60 disabled:hover:scale-100"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              Receber capítulo
            </button>
          </form>
          <p className="mt-4 text-xs text-zinc-600">Sem spam. Apenas o capítulo e reflexões estoicas ocasionais.</p>
        </Reveal>
      </div>
    </section>
  );
};
